import { Schema, picid } from './common_schema.js';
import { AccountSchema } from './account_schema.js';

const size = Schema.Optional(Schema.Int);
const pic = Schema.NotEmptyString;

const lat = Schema.Float;
const lng = Schema.Float;
const provider = Schema.String;

const name = Schema.String;

// Use string since cameras use non ISO date format.
const date = Schema.Default(Schema.Date, null);
const description = Schema.String;

const info = Schema.Optional(
  Schema.Object({
    name,
    date,
    description,
    lat: Schema.Optional(lat),
    lng: Schema.Optional(lng),
  })
);

const north = Schema.Float;
const south = Schema.Float;
const west = Schema.Float;
const east = Schema.Float;

const schema = {
  'get-default-location': new Schema({}),
  'change-avatar': new Schema({
    avatar: Schema.String,
  }),
  'change-name': new Schema({
    name: Schema.NotEmptyString,
  }),
  'change-pwd': new Schema({
    old_pwd: Schema.NotEmptyString,
    pwd: Schema.NotEmptyString,
  }),
  'get-info': new Schema({}),
  'get-pic': new Schema({
    picid,
    size,
  }),
  'get-pics': new Schema({
    north,
    east,
    south,
    west,
  }),
  'reverse-geocode': new Schema({
    lat,
    lng,
    provider,
  }),
  'upload-pic': new Schema({
    pic,
    info,
  }),
  'set-pic-description': new Schema({
    id: pic,
    description,
  }),
};

// TODO: rework request server to not run all account related logic
// through the service module.
const AccountSchemaBorrows = [
  'cancel-password-recovery',
  'check-password-recovery-hash',
  'identify',
  'recover-password',
  'reset-password',
  'signup',
];
for (let name of AccountSchemaBorrows) {
  schema[name] = AccountSchema[name];
}

const schemaFields = {
  id: picid,
  name,
  description,
  lat: Schema.Default(lat, null),
  lng: Schema.Default(lng, null),
  date,
  north,
  east,
  south,
  west,
};

export { schema as ServiceSchema, schemaFields as ServiceSchemaFields };
